






























































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import SearchTree from "@/lib/Common/searchtree";
import CreateSMSConfig from "./createsmsconfig.vue";
import EditSMSConfig from "./editsmsconfig.vue";
import CopySMSConfig from "./copysmsconfig.vue";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageLogsRequest extends PageRequest {
  keyword: string;
  smsPlatform: number;
}

@Component({
  components: { CreateSMSConfig, EditSMSConfig, CopySMSConfig },
})
export default class SMSConfig extends AbpBase {
  //filters
  pagerequest: PageLogsRequest = new PageLogsRequest();
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  createModalShow: boolean = false;//新增
  editModalShow: boolean = false;//编辑
  copyModalShow: boolean = false;//复制
  splitnum: number = 0.15;
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  //修改
  edit() {
    this.editModalShow = true;
  }
  //新增
  create() {
    this.createModalShow = true;
  }
  //复制
  async copy() {
    this.copyModalShow = true;
  }
  //排序
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  //列表
  get list() {
    return this.$store.state.smsconfig.list;
  }
  get loading() {
    return this.$store.state.smsconfig.loading;
  }
  getItemId() {
    // let item = (this.$refs.tree as any).getSelectedNodes();
    // if (item.length > 0) {
    //   this.pagerequest.areaId = item[0].id;
    // }
    this.$store.commit("smsconfig/setCurrentPage", 1);
    this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("smsconfig/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("smsconfig/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "smsconfig/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.smsconfig.pageSize;
  }
  get totalCount() {
    return this.$store.state.smsconfig.totalCount;
  }
  get currentPage() {
    return this.$store.state.smsconfig.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      title: this.L("IndexNo"),
      fixed: "left",
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].displayName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].displayName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: info.length > 0 ? info[0].fullName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].fullName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Name"),
      key: "name",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.name,
            },
          },
          params.row.name
        );
      },
    },
    {
      title: this.L("WaringType"),
      key: "waringType",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.waringType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : "未知");
      },
    },
    {
      title: this.L("SMSPlateform"),
      key: "smsPlatform",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.smsPlatform;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : "未知");
      },
    },
    {
      title: this.L("SMSUrl"),
      key: "smsUrl",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.smsUrl,
            },
          },
          params.row.smsUrl
        );
      },
    },
    {
      title: this.L("SMSAppId"),
      key: "smsAppId",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.smsAppId,
            },
          },
          params.row.smsAppId
        );
      },
    },
    {
      title: this.L("SMSAppSecret"),
      key: "smsAppSecret",
      width: 160,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.smsAppSecret,
            },
          },
          params.row.smsAppSecret
        );
      },
    },
    {
      title: this.L("SMSTemplateId"),
      key: "smsTemplateId",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.smsTemplateId,
            },
          },
          params.row.smsTemplateId
        );
      },
    },
    {
      title: this.L("SMSSender"),
      key: "smsSender",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.smsSender,
            },
          },
          params.row.smsSender
        );
      },
    },
    {
      title: this.L("NotifyUrl"),
      key: "smsCallbackUrl",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.smsCallbackUrl,
            },
          },
          params.row.smsCallbackUrl
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 190,
      fixed: "right",
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('smsconfigEdit');
        let edit = this.checkButtonAuth('smsconfigDel');
        return h("div", [
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("smsconfig/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "smsconfig/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    await this.getItemDetail();
    console.log(this.$data.waringType)
    this.getAreaTree();
    this.getpage();
  }

  async getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let info = detaillist.filter((p) => {
        return p.itemId == 23;
      });
      info.forEach((ele) => {
        this.$data.smsPlatform.push({
          label: ele.name,
          value: ele.id,
        });
      });
      info = detaillist.filter((item) => {
        return item.itemId == 18;
      })
      info.forEach((item) => {
        this.$data.waringType.push({
          label: item.name,
          value: item.id,
        })
      });
    }
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    this.areaTree = SearchTree.searnchTree(value, treeList);
  }
  //区域
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  data() {
    return {
      smsPlatform: [],
      waringType: [],//告警类型
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
